import {WellnessMediaList, QueryWellnessSearchArgs} from "@irati/types"
import {createUseQuery} from "@irati/utils/services/apollo"
import {gql} from "@irati/utils/gql"
import useDebounce from "@irati/utils/hooks/useDebounce"

const useWellnessSearchBase = createUseQuery<WellnessMediaList, QueryWellnessSearchArgs>(
  gql`
    query WellnessSearch($offset: Int, $limit: Int, $search: String, $tags: [String!], $categoryId: ID) {
      wellnessSearch(offset: $offset, limit: $limit, search: $search, tags: $tags, categoryId: $categoryId) {
        count
        results {
          id
          uuid
          title
          description
          duration
          type
          thumbnail
          provider {
            uuid
            name
          }
          category {
            id
            uuid
            name
            mediaLabel
            svgData
          }
          author {
            uuid
            name
          }
        }
      }
    }
  `,
  {key: "wellnessSearch"}
)

const DEBOUNCE_TIME = 300

export const useWellnessSearch = (args: QueryWellnessSearchArgs, opts: {debounceTime?: number} = {}) => {
  const debouncedSearch = useDebounce(args, opts.debounceTime ?? DEBOUNCE_TIME)
  const apollo = useWellnessSearchBase(debouncedSearch, {skip: !debouncedSearch.search})

  return apollo
}
